import React, { useState } from "react";

export const Gallery = () => {
  // Cantidad de imágenes según sea necesario
  const totalImages = 18;

  const data = Array.from({ length: totalImages }, (_, i) => {
    const number = String(i + 1).padStart(2, "0"); // Formato 01, 02, etc.
    return {
      title: `Imagen ${number}`,
      largeImage: `/img/portfolio/${number}-large.jpg`, // Ruta para la imagen grande
      smallImage: `/img/portfolio/${number}-small.jpg`, // Ruta para la imagen pequeña
    };
  });

  const [modalImage, setModalImage] = useState(null); // Guardamos la imagen que se va a mostrar en el modal
  const [showModal, setShowModal] = useState(false); // Estado para controlar la visibilidad del modal

  const openModal = (image) => {
    setModalImage(image); // Establecemos la imagen que se va a mostrar
    setShowModal(true); // Mostramos el modal
  };

  const closeModal = () => {
    setShowModal(false); // Ocultamos el modal
    setModalImage(null); // Limpiamos la imagen del modal
  };

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>¡Explora Nuestras Máquinas Expendedoras!</h2>
          <p>
            Descubre la innovación y la tecnología en cada una de nuestras máquinas expendedoras
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg" onClick={() => openModal(d.largeImage)}>
                    <div className="hover-text">
                      <h4>{d.title}</h4>
                    </div>
                    <img
                      src={d.smallImage}
                      className="img-responsive"
                      alt={d.title}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

  {/* Modal */}
{showModal && (
  <div className="container-fluid">
    <div
      className="modal-backdrop fade in"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}
    ></div>

    <div
      className="modal fade in"
      id="myModal"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="false"
      style={{ display: "block" }} // Aseguramos que el modal se muestre
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="myModalLabel">
              Imagen
            </h4>
          </div>
          <div
            className="modal-body"
            style={{
              maxHeight: "80vh", // Altura máxima del modal
              overflowY: "auto", // Scroll vertical si se necesita
              textAlign: "center",
            }}
          >
            {modalImage && (
              <img
                src={modalImage}
                alt="Modal"
                className="img-responsive"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
)}
   </div>
  );
};



 